// Carnivoro loyalty scoring — pure functions, Node + browser compatible.
// Adapted to the Carnivoro catch game (not Tetris).
//
// Raw score is already computed in-game as state.score. This module only
// handles the raw-score -> loyalty-points conversion.

'use strict';

var FLOOR = 100;           // minimum points any completed game awards
var CAP = 800;             // hard cap
var TARGET_AVG = 400;      // target mean (used for tuning K via simulate.js)
var K = 2000;              // log-curve steepness — tune against simulation
var MAX_EXPECTED_SCORE = 35000; // raised — skilled players can survive ~5 min now
var FORCE_END_MS = 1800000; // 30 min ceiling — endless mode after the third boss

// Catch-game points-per-second cap used by the validator.
// Max theoretical pace: top level spawn 300ms + carnivoro mode x2 mult + streak x3
// => ~28 items/sec * ~20 pts/item  => ~560 pts/sec peak bursts. We allow 250
// as a sustained ceiling; anything higher is inhuman.
var MAX_PTS_PER_SEC = 250;

function scoreToPoints(rawScore) {
  if (!isFinite(rawScore) || rawScore < 0) rawScore = 0;
  var logPoints = FLOOR + (CAP - FLOOR) *
    Math.log(1 + rawScore / K) / Math.log(1 + MAX_EXPECTED_SCORE / K);
  var rounded = Math.round(logPoints / 50) * 50;
  return Math.min(CAP, Math.max(FLOOR, rounded));
}

var CONSTANTS = {
  FLOOR: FLOOR,
  CAP: CAP,
  TARGET_AVG: TARGET_AVG,
  K: K,
  MAX_EXPECTED_SCORE: MAX_EXPECTED_SCORE,
  FORCE_END_MS: FORCE_END_MS,
  MAX_PTS_PER_SEC: MAX_PTS_PER_SEC
};

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { scoreToPoints: scoreToPoints, CONSTANTS: CONSTANTS };
} else if (typeof window !== 'undefined') {
  window.CarnivoroScoring = { scoreToPoints: scoreToPoints, CONSTANTS: CONSTANTS };
}
